import script from "./team-info.vue?vue&type=script&setup=true&lang=ts"
export * from "./team-info.vue?vue&type=script&setup=true&lang=ts"

import "./team-info.vue?vue&type=style&index=0&id=35a18d26&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a18d26"]])

export default __exports__